import { create } from "zustand";

interface OfflineState {
  visible: boolean;
  reportOffline: () => void;
  clear: () => void;
}

/**
 * Blocking "no connection" overlay. `clear` runs only from the `online` event
 * inside `OfflineOverlay` — there is no dismiss button.
 */
export const useOfflineStore = create<OfflineState>((set) => ({
  visible: false,
  reportOffline: () => set({ visible: true }),
  clear: () => set({ visible: false }),
}));
